package com.royceecoleman.bill.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun analyticsPage() {
    GuardedAdminPage("Loading BILL operations.", "Sign in to use admin tools.", "Admin access required.") { OperationsPanel() }
}
